import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";

// ⚠️ حط هنا نفس اللوجو اللي في Navbarefixed (انسخ سطر الاستيراد منه بنفس المسار)
import logo from "../Assets/logo.png";
// ⚠️ صورة الخلفية: حط الصورة في فولدر Assets بالاسم ده (أو غيّر الاسم هنا)
import bg from "../Assets/preloader.jpg";

// ============ التوقيت (عدّله براحتك) ============
const OPEN_AT = 1500; // بعد كام مللي ثانية تبدأ الفتحة (يسيب وقت للسقوط والارتداد)
const OPEN_DURATION = 1.3; // مدة الفتحة بالثواني
const EASE = [0.76, 0, 0.24, 1];

export const Preloader = ({ onOpen, onDone }) => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const t1 = setTimeout(() => {
      setOpen(true);
      if (onOpen) onOpen(); // الهيرو يبدأ أنيميشن الدخول مع بداية الفتحة
    }, OPEN_AT);
    const t2 = setTimeout(() => onDone && onDone(), OPEN_AT + OPEN_DURATION * 1000 + 100);
    return () => {
      clearTimeout(t1);
      clearTimeout(t2);
    };
  }, [onOpen, onDone]);

  // كل نص فيه نسخة كاملة من الصورة واللوجو متقصوصة، فلما النصين يتفرقوا الكل بيتقسم معاهم
  const half = (pos) => (
    <motion.div
      className={`pre__half pre__half--${pos}`}
      initial={false}
      animate={{ y: open ? (pos === "top" ? "-101%" : "101%") : "0%" }}
      transition={{ duration: OPEN_DURATION, ease: EASE }}
    >
      <div className="pre__stage">
        <img className="pre__logo" src={logo} alt="" />
      </div>
    </motion.div>
  );

  return (
    <div className="pre" role="presentation" aria-hidden="true" style={{ "--pre-bg": `url(${bg})` }}>
      {half("top")}
      {half("bottom")}
    </div>
  );
};